// extracted by mini-css-extract-plugin
export default {"value":"StreamText_value__Gyafz","showValue":"StreamText_showValue__VhT+f"};